import * as WebFont from 'webfontloader';
import { LocalizationContents } from './game/LocalizationContents';
import { Games, IReleasePlatform } from './index';

declare global {
    interface Window { CrazyGames: any; }
}

WebFont.load({
    custom: {
        families: [
            'BIPs',
            'Action Man',
            'ARCO Cyrillic',
            'BD Cartoon Shout',
        ],
    },
    loading: () => {
        LocalizationContents.setLanguage()
            .then(() => {
                Games.startGame({
                    releasePlatform: IReleasePlatform.standalone,
                });
            });
    },
});
